// Wire shapes for Module 1 (Physician Onboarding & Portal Access), 1:1 with the
// MODULE 1 API CONTRACT. camelCase throughout, matching the existing SignupRequest.

/** DECLINED: the invitee said no from the email's decline link. */
export type InvitationStatus = "AWAITING_SIGNUP" | "ACCEPTED" | "CANCELLED" | "EXPIRED" | "DECLINED";

export const INVITATION_STATUSES: InvitationStatus[] = ["AWAITING_SIGNUP", "ACCEPTED", "CANCELLED", "EXPIRED", "DECLINED"];

/** `status` is the EFFECTIVE status: an AWAITING_SIGNUP row past expiresAt arrives as EXPIRED. */
export interface PhysicianInvitation {
  id: string;
  email: string;
  status: InvitationStatus;
  expiresAt: string;
  createdAt: string;
  acceptedAt?: string | null;
}

export interface ResentInvitation {
  id: string;
  email: string;
  status: "AWAITING_SIGNUP";
  expiresAt: string;
}

export interface CancelledInvitation {
  id: string;
  status: "CANCELLED";
}

export interface PhysicianListItem {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  joinedAt: string;
}

export interface ItemsResponse<T> {
  items: T[];
}

export interface InvitePreview {
  email: string;
  expiresAt: string;
}

/** Accepting an invitation takes only a password; the email comes from the invitation. */
export interface PhysicianSignupRequest {
  token: string;
  password: string;
  confirmPassword: string;
}

export interface PhysicianProfile {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
}

/**
 * "Same shapes as the patient equivalents" — the patient portal returns
 * { accessToken, expiresIn?, patient }. The contract doesn't name the user key
 * for physicians, so it's read loosely here and the header name comes from
 * GET /api/physician/me instead (see PhysicianLayout).
 */
export interface PhysicianAuthResponse {
  accessToken: string;
  expiresIn?: number;
  physician?: PhysicianProfile;
  user?: PhysicianProfile;
}

export interface MessageResponse {
  message?: string;
}
